import {BigDecimal} from '@dms/api/shared';

export type DepositCashPaymentRequestBody = {
  paymentDiscriminator: DepositCashPaymentRequestBody.paymentDiscriminator;
  paymentMethod: DepositCashPaymentRequestBody.paymentMethod;
  dueDate: string;
  cashRegisterId: string;
  amount: BigDecimal;
  comment: string;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace DepositCashPaymentRequestBody {
  export enum paymentDiscriminator {
    DEPOSIT = 'DEPOSIT',
  }

  export enum paymentMethod {
    CASH = 'CASH',
  }
}
